import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Spinner from 'src/view/components/Controls/Spinner/Spinner';
import './style.scss';

interface IProps {
  value?: string;
  onClick?: () => void;
  placeholder?: string;
  loading?: boolean;
  disabled?: boolean;
  error?: boolean;
  withoutIcon?: boolean;
  className?: string;
  textClassName?: string;
  wrapperClassName?: string;
  placeholderClassName?: string;
  prevComponent?: React.ReactNode;
}

/**
 * Component - button imitating picker
 */
const FakePicker: React.FC<IProps> = observer((props: IProps): JSX.Element => {
  const onClick = () => {
    if (props.disabled || props.loading) return;
    if (props.onClick) props.onClick();
  };

  const renderContent = useCallback((): JSX.Element => {
    return props.value ? (
      <span className={`text-elipsis ${props.textClassName || ''}`}>{props.value}</span>
    ) : (
      <span className={`placeholder ${props.placeholderClassName || ''}`}>{props.placeholder}</span>
    );
  }, [props.value, props.placeholder, props.textClassName, props.placeholderClassName]);

  const renderIcon = useCallback((): JSX.Element | null => {
    if (props.withoutIcon) return null;

    if (props.loading) {
      return (
        <div className="d-flex ml-3 pos-absolute pos--right__4 pos--top__8">
          <Spinner color={theme.colors.gray2} />
        </div>
      );
    }

    return <Icon name={Icons.Chevron} className="color-gray2" size={20} />;
  }, [props.loading, props.withoutIcon]);

  const inputClassName = useMemo((): string => {
    let className = 'input input-mini fake-picker__input';

    if (props.className) className += ` ${props.className}`;
    if (props.error) className += ' input-error';

    return className;
  }, [props.className, props.error]);

  return (
    <div className={`d-flex family-regular text-size-16 cursor-pointer ${props.wrapperClassName || ''}`}>
      <div className={inputClassName} onClick={onClick}>
        {props.prevComponent ? (
          <div className="fake-picker__wrapper">
            {props.prevComponent}
            {renderContent()}
          </div>
        ) : (
          renderContent()
        )}
        {renderIcon()}
      </div>
    </div>
  );
});

export default FakePicker;
